import {
  BookingsResponseV2,
  BookingResponse,
  BookingListItemResponse,
  BookingsListResponseV2,
} from 'api/gen'
import { getTimeZonedDate } from 'libs/parsers/formatDates'

const convertBookingsListDatesToTimezone = (bookings: BookingResponse[]): BookingResponse[] => {
  return bookings?.map(convertBookingResponseDateToTimezone)
}

export const convertBookingResponseDateToTimezone = <
  T extends BookingResponse | BookingListItemResponse,
>(
  booking: T
): T => {
  const timezone = booking.stock.offer.address?.timezone ?? booking.stock.offer.venue.timezone
  return {
    ...booking,
    stock: {
      ...booking.stock,
      beginningDatetime: booking.stock.beginningDatetime
        ? getTimeZonedDate({
            date: new Date(booking.stock.beginningDatetime),
            timezone,
          }).toISOString()
        : null,
    },
  }
}

export const convertBookingsResponseV2DatesToTimezone = (
  bookings: BookingsResponseV2
): BookingsResponseV2 => ({
  hasBookingsAfter18: bookings.hasBookingsAfter18,
  ongoingBookings: convertBookingsListDatesToTimezone(bookings.ongoingBookings),
  endedBookings: convertBookingsListDatesToTimezone(bookings.endedBookings),
})

export const convertBookingsListResponseV2DatesToTimezone = (
  bookingsResponse: BookingsListResponseV2
): BookingsListResponseV2 => ({
  ...bookingsResponse,
  bookings: bookingsResponse.bookings.map(convertBookingResponseDateToTimezone),
})
